import React, { Component } from 'react';
import { Carousel } from 'react-bootstrap';
import { IReducerState } from '../../states/renditionStates';
import { connect } from 'react-redux';
import * as asyncStateAction from '../../actions/asyncStateAction';
import servicesConfig from '../../services/servicesConfig';
import '../../../style/features/carousel.scss';
import { RSCH_HTML_TRACKING_CONFIG } from '../../readership/trackingConfig';
import { cv_openCampaignPage } from '../../cvMobile/cvCampaign';
import { isCVMobileApp } from '../../utils/general/general';
import { enterKeyPressed } from '../../utils/general/enterKey';
import $ from 'jquery';

interface ICarouselCampaignsProps {
    loadCampaignsSource: () => {};
    campaignsSource: any;
    showDefaultImg: boolean;
}

export class CarouselCampaigns extends Component<ICarouselCampaignsProps, any> {

    constructor(props: ICarouselCampaignsProps) {
        super(props);
        if (props.showDefaultImg) props.loadCampaignsSource();
    }

    public openCampaignPage(url: any) {
        const { campaignsSource } = this.props;
        if (isCVMobileApp()) {
            return cv_openCampaignPage(url, campaignsSource);
        }
        RSCH_HTML_TRACKING_CONFIG.trackCampaignClick(campaignsSource.campaigns[0]['campaignID'],campaignsSource.campaigns[0]['cvcampaign']);
        window.open(decodeURIComponent(url), "_blank");
    }

    public componentDidMount() {
        this.appendADAAttributes();
    }

    public appendADAAttributes() {
        setTimeout(() => {
            $('#campaigns .carousel-control-prev:visible').attr('tabindex', '0');
            $('#campaigns .carousel-control-next:visible').attr('tabindex', '0');
            $('#campaigns .carousel-control-prev:visible').attr('aria-label', 'Previous');
            $('#campaigns .carousel-control-next:visible').attr('aria-label', 'Next');
            $('#another_campaigns_contain .carousel-control-prev:visible').attr('tabindex', '0');
            $('#another_campaigns_contain .carousel-control-next:visible').attr('tabindex', '0');
            $('#another_campaigns_contain .carousel-control-prev:visible').attr('aria-label', 'Previous');
            $('#another_campaigns_contain .carousel-control-next:visible').attr('aria-label', 'Next');
        }, 500);
    }

    public handleSelect() {
        $('#campaigns_contain .carousel-item.carousel-item').attr('aria-selected', 'false');
        $('#campaigns_contain .carousel-item.active.carousel-item').attr('aria-selected', 'true');
        $('#another_campaigns_contain .carousel-item.carousel-item').attr('aria-selected', 'false');
        $('#another_campaigns_contain .carousel-item.active.carousel-item').attr('aria-selected', 'true');
    }

    public renderCarouselCampaign() {
        const { campaignsSource, showDefaultImg } = this.props;
        if (campaignsSource == "NODATA") {
            return null;
        }
        if (campaignsSource.campaigns && campaignsSource.campaigns.length > 0) {
            let index = 0;
            const template: Array<any> = [];
            const campaignList: Array<any> = [];

            campaignsSource.campaigns.forEach((campaignItem: any) => {
                if (!campaignItem.ismarketingbanner) {
                    campaignList.push(campaignItem);
                }
            });

            campaignList.forEach((campaign, idx) => {
                if ((campaign.isDefault == false && !showDefaultImg) || (campaign.isDefault && showDefaultImg)) {
                    index++;
                    template.push(<Carousel.Item tabIndex={0} aria-selected={idx === 0 ? true : false} key={idx} role='option' onClick={() => this.openCampaignPage(campaign.campaignurl)}
                    onKeyPress={(e) => enterKeyPressed(e, this.openCampaignPage.bind(this, campaign.campaignurl))} aria-label={campaign.campaigntitle}>
                        <a role="link" id={'campaignLink' + idx} data-name={campaign.campaignid} aria-label={campaign.campaigntitle}>
                            <img role="img" className={campaign.isDefault ? 'default-campaign-img' : 'campaign-img'}
                                 alt={campaign.campaigntitle}
                                 src={campaign.campaignimageurl}
                                 width='100%' height='100%'
                            />
                        </a>
                    </Carousel.Item>);
                }
            });

            return <Carousel indicators={false} controls={(index > 1)} keyboard={true} role={index ? 'listbox' : 'region'} aria-label='campaign slider' onSelect={() => this.handleSelect()}>
                    {template}
                </Carousel>;
        }
    }

    public render() {
        return (
            <React.Fragment>
                {this.renderCarouselCampaign()}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        campaignsSource: state.asyncStateReducer.campaignsSource
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        loadCampaignsSource: () => dispatch(asyncStateAction.fetchCampaignsData(servicesConfig.GET_CAMPAIGNS))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CarouselCampaigns);